import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=bc58e56a&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=bc58e56a&prod&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=bc58e56a&prod&scoped=true&lang=css&"
import style2 from "./detail.vue?vue&type=style&index=2&id=bc58e56a&prod&lang=css&"
import style3 from "./detail.vue?vue&type=style&index=3&id=bc58e56a&prod&lang=css&"
import style4 from "./detail.vue?vue&type=style&index=4&id=bc58e56a&prod&scoped=true&lang=css&"
import style5 from "./detail.vue?vue&type=style&index=5&id=bc58e56a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc58e56a",
  null
  
)

export default component.exports